var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"7499c983d3bfa665c0fb2f689d915ce217ad4d4b"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["seedlang@seedlang"]={id:"7499c983d3bfa665c0fb2f689d915ce217ad4d4b"};
      